import {IMuWidget} from "./IMuWidget";
import {Ajax} from "./Ajax";
import {UiSelector} from "./UiSelector";
import {Sortable} from "sortablejs";

export class UiScripting extends IMuWidget {
	public url : {
		preview : string
	};

	constructor(container : HTMLElement) {
		super();
		container.querySelector('[name="jsonSrc"]').setAttribute("mu-id", "jsonSrc");
	}

	afterIndex() {
		/* this.muNamedWidget.actions = this.muWidgetFromTemplate("ancestor:actionList", "actionListContainer");
		this.ui.actions = this.muNamedWidget.actions.container; */

		this.bindFromSrc();
	}

	bindFromSrc() {
		const src = JSON.parse(this.ui.jsonSrc.value);
		this.bindActionList(src);
	}

	showCode_click()
	{
		const ajax = new Ajax(this.url.preview);
		ajax.method = "POST";
		ajax.setData({code:  this.ui.jsonSrc.value });
		ajax.jsonResult = true;
		ajax.then(data => {
			this.ui.code.innerText = data.code + "\n\n" + data.errors;
		});
		ajax.call();
		/* this.ajax(
			"preview",
			{"code": this.ui.jsonSrc.value },
			function(data) {
				this.ui.code.innerText = data.code + "\n\n" + data.errors;
			}
		)*/
	}

	bindActionList(actions : ActionSrc[])
	{
		const actionList = this.muNamedWidget.actions as UiScriptingActionList;
		actionList.clear();
		actionList.addRange(actions);
		// this.updateSortable();
	}
}

export abstract class UiScriptingAction extends IMuWidget {
	public action: ActionSrc;

	abstract bind(action : ActionSrc);

	abstract fetch() : ActionSrc;

	afterIndex() {
		this.bind(this.action);
	}
}

export class UiScriptingActionList extends IMuWidget
{
	public static commandToTemplate : Record<Operation, string> = {
		"=": "actionAssign",
		call: "actionCall",
		default: "actionDefault",
		if: "actionIf",
		php: "actionPhp",
		exit: "actionExit"
	}
	public add(src : ActionSrc)
	{
		let operation = src[0];
		const useReturnValue = operation[0] == "=";
		if (useReturnValue) operation = operation.substr(1);
		let template;
		let callName = null;
		if (UiScriptingActionList.commandToTemplate[operation])
		{
			template = UiScriptingActionList.commandToTemplate[operation];
		}
		else
		{
			template = "actionCall";
			callName = operation;
		}
		const wAction = this.muWidgetFromTemplate(
			"ancestor:" + template,
			"actions",
			{ action: src }
		);
		// remove icon
		const hRemove = document.createElement("span");
		hRemove.innerHTML = "&#x1F5D1;";
		hRemove.className = "close";
		hRemove.addEventListener("click", () => {
			if (confirm("Opravdu odebrat tuto akci?"))
				wAction.muRemoveSelf()
		});
		wAction.container.querySelector("legend").appendChild(hRemove);
	}

	public addRange(actionList: ActionSrc[]) {
		for(const action of actionList) this.add(action);
		this.updateSortable();
	}

	private updateSortable() {
		const sortable = Sortable.create(this.ui.actions, {
			handle: "legend",
			animation: 75																															,
			// onSort: () => this.saveOrder()
		});
	}

	clear() {
		this.ui.actions.innerHTML = "";
	}

	bAdd_click()
	{
		if (this.ui.operationType.value)
		{
			this.add([this.ui.operationType.value]);
			/* const template = UiScriptingActionList.commandToTemplate[this.ui.operationType.value];
			this.muWidgetFromTemplate(
				template,
				"actions",
				{ action: [] }
			);*/
		} else {
			alert("Vyberte akci");
		}
	}

	afterIndex() {
		const opts = {
			"": "Vyberte",
			...operationTitles
		};
		this.muBindData({operationTypes: opts});

	}

	bind(actions: ActionSrc[]) {
		this.ui.actions.innerHTML = "";
		if (actions) this.addRange(actions);
		// this.
	}

	fetch(): ActionSrc[] {
		const res : ActionSrc[] = [];

		for(const el of this.ui.actions.childNodes)
		{
			res.push((el.widget as UiScriptingAction).fetch());
		}

		return res;
	}
}

/* export class UiScriptingActionBase extends UiScriptingAction
{
	bind(action: ActionSrc) {
	}

	fetch(): ActionSrc {
		return this.action;
	}
} */

export class UiScriptingActionDefault extends UiScriptingAction
{
    bind(action: ActionSrc) {
		this.ui.variable.value = action[1];
		(this.muNamedWidget.defaultValue as UiParameter).setValue(action[2]);
    }
    fetch(): ActionSrc {
        return [ "default", this.ui.variable.value, (this.muNamedWidget.defaultValue as UiParameter).getValue() ]
    }
}

export class UiScriptingActionCall extends UiScriptingAction
{
	bind(action: ActionSrc) {
		const urv = action[0][0] == "=";
		this.ui.useReturnValue.checked = urv;
		this.ui.operation.value = this.ui.useReturnValue.checked
			? action[0].substr(1) : action[0];
		if (urv) this.ui.returnValueVariable.value = action[1];

		for(const param of action.slice(urv ? 2 : 1))
		{
			const arg = this.muWidgetFromTemplate(
				"argument", "arguments",
				<UiParameter>{sortable: true, removable: true}
			) as UiParameter;
			arg.setValue(param);
		}
		// (this.muNamedWidget.defaultValue as UiParameter).setValue(action[2]);
	}

	fetch(): ActionSrc {
		const urv = this.ui.useReturnValue.checked;
		const ret : ActionSrc = [ (urv ? "=" : "") + this.ui.operation.value ];
		if (urv) ret.push(this.ui.returnValueVariable.value);
		for(const el of IMuWidget.getChildWidgets(this.ui.arguments))
		{
			ret.push((el as UiParameter).getValue());
		}
		return ret;
	}

	useReturnValue_change() {
		this.muVisible(this.ui.useReturnValue.checked, "returnValueVariable")
	}

	bAddArgument_click() {
		this.muWidgetFromTemplate(
			"argument", "arguments",
			<UiParameter>{sortable: true, removable: true}
		);
	}
}

export class UiScriptingActionPHP extends UiScriptingAction
{
	bind(action: ActionSrc) {
		this.ui.phpSrc.value = action[1] || "";
	}

	fetch(): ActionSrc {
		return [ "php", this.ui.phpSrc.value ];
	}
}

export class UiParameter extends IMuWidget
{
	private typeSelector: UiSelector;
	public removable: boolean;
	public sortable: boolean;

	constructor(container : HTMLElement) {
		super();
		container.innerHTML += `
			<span mu-id="type" mu-widget="UiSelector" class="ui-selector">
				<span mu-template="item"></span>
			</span>
			<input type="text" mu-id="value" />			
			<span mu-id="hSortable" class="sortable-handler pull-left">&#x21C5;</span>
			<span mu-id="bRemove" class="close">&#x1F5D1;</span>
			<textarea mu-id="valueArea" class="form-control"></textarea>`;
	}
	afterIndex() {
		this.typeSelector = this.muNamedWidget.type as UiSelector;
		this.typeSelector.textField = "text";
		this.typeSelector.bindValues([
			{ value: "variable", text: "proměnná" },
			{ value: "string", text: "text" },
			{ value: "number", text: "číslo" },
			{ value: "true", text: "ano" },
			{ value: "false", text: "ne" },
			{ value: "null", text: "nic" },
			{ value: "json", text: "JSON" },
		]);
		this.type_change();
		this.muVisible(this.sortable, "hSortable");
		this.muVisible(this.removable, "bRemove");
	}
	type_change() {
		const type = this.typeSelector.getActive();
		this.muVisible(type == "variable" || type == "number", "value");
		this.muVisible(type == "json" || type == "string", "valueArea");
	}
	setValue(value) {
		let type : ParamType;
		if (value === null)
		{
			type = "null";
		}
		else
		switch (typeof value)
		{
			case "string":
				switch (value[0]) {
					case "'":
						type = "string";
						break;
					case "$":
						type = "variable";
						break;
				}
				value = value.substr(1);
				break;
			case "number":
				type = "number";
				value = "";
				break;
			case "boolean":
				type = value ? "true" : "false";
				value = "";
				break;
			case "object":
				type = "json";
				value = JSON.stringify(value, null, 4);
				break;

		}
		this.typeSelector.setActive(type);
		this.ui.value.value = this.ui.valueArea.value = value;
		this.ui.value.type = type == "number" ? "number" : "text";
		this.type_change();
	}
	getValue() : any {
		switch (<ParamType>this.typeSelector.getActive())
		{
			case "false": return false;
			case "true": return true;
			case "null": return null;
			case "string": return "'" + this.ui.valueArea.value;
			case "number": return parseFloat(this.ui.value.value);
			case "variable": return "$" + this.ui.value.value;
			case "json": return JSON.parse(this.ui.valueArea.value)
		}
	}
	bRemove_click()
	{
		if (confirm("Odebrat argument?"))
			this.muRemoveSelf()
	}
}

export class UiScriptingActionIf extends UiScriptingAction
{
	override afterIndex() {
		/* for(const n of ["then", "else"])
		{
			this.muNamedWidget[n] = this.muWidgetFromTemplate("ancestor:actionList", n + "Container");
			this.ui[n] = this.muNamedWidget[n].container;
		} */
		super.afterIndex();
	}

	bind(action: ActionSrc) {
		(this.muNamedWidget.then as UiScriptingActionList).bind(action[2]);
		(this.muNamedWidget.else as UiScriptingActionList).bind(action[3]);
	}

	fetch(): ActionSrc {
		return undefined;
	}
}

export class UiCondition extends IMuWidget
{
	bind(condition : ConditionSrc) {

	}
}

export type Operation = "if"|"exit"|"php"|"="|"default"|"call"|string;

export const operationTitles : Record<Operation, string> = {
	"if": "Podmínka",
	"exit": "Ukončit script",
	"php": "PHP kód",
	"=": "Přiřazení",
	"default": "Výchozí hodnota",
	"call": "Provést",
}

export type ConditionOperator = "and"|"or"|"nand"|"nor"|">"|"<"|">="|"<="|"=="|"!="|"!"|""|"in";

type ConditionOpt = {
	name: string,
	prefix?: string,
	textBetween?: string,
	paramCount: 1|2|"*"
}

const ConditionOpts : Record<ConditionOperator, ConditionOpt> = {
	"": { name: "Je pravda", paramCount: 1 },
	"!": { name: "Není pravda (NOT)", paramCount: 1 },
	"!=": { name: "Nerovná se", textBetween: "nerovná se", paramCount: 2 },
	"<": { name: "Je menší než", textBetween: "je menší než", paramCount: 2 },
	"<=": { name: "Je menší nebo rovno", textBetween: "je menší nebo rovno", paramCount: 2 },
	"==": { name: "Rovná se",   textBetween: "rovná se", paramCount: 2 },
	">": { name: "Je větší než", textBetween: "je větší než", paramCount: 2 },
	">=": { name: "Je větší nebo rovno", textBetween: "je větší nebo rovno", paramCount: 2 },
	in: { name: "Je jeden z", paramCount: 2 },
	and: { name: "Více podmínek: Je pravda vše (AND)", prefix: "Je pravda že", textBetween: "a zároveň", paramCount: "*" },
	nand: { name: "Více podmínek: Není pravda nic (NAND)", prefix: "Není pravda že", textBetween: "a zároveň", paramCount: "*" },
	or: { name: "Více podmínek: Je pravda něco (OR)", prefix: "Je pravda že", textBetween: "a nebo", paramCount: "*" },
	nor: { name: "Více podmínek: Není pravda něco (NOR)", prefix: "Není pravda že", textBetween: "a nebo", paramCount: "*" },
};

export class UiActionConditionList extends IMuWidget {

}

export class UiActionCondition extends IMuWidget {

}

export type ActionSrc = [ Operation, ...any ];

export type ConditionSrc = [ ConditionOperator, ...any ];

export type ParamType = "variable"|"string"|"number"|"true"|"false"|"json"|"null";
